import React from 'react';
import { Route, Switch } from 'react-router-dom';
import deviceDetailsRoutes from '../../routes/DeviceDetailsRoutes';
import SimpleHeader from '../LayoutComponents/SimpleHeader/SimpleHeader';

const DeviceDetailsLayout = (): JSX.Element => {
  return (
    <>
      <SimpleHeader />
      <div className='d-flex justify-content-center'>
        <div className='p-3 d-flex flex-column'>
          <Switch>
            {deviceDetailsRoutes.map(({ path, component }, key) => (
              <Route path={path} component={component} key={key} />
            ))}
          </Switch>
        </div>
      </div>
    </>
  );
};

export default DeviceDetailsLayout;
